const propertyActionTypes = {
  GET_BUILDING: 'GET_BUILDING',
  SET_BUILDING: 'SET_BUILDING',
  GET_APP: 'GET_APP',
  GET_CLAIM: 'GET_CLAIM',
  SET_APP: 'SET_APP',
  SET_CLAIM: 'SET_CLAIM',
  SET_ERR: 'GET_ERR',
  GET_POLICY: 'GET_POLICY',
  SET_POLICY: 'SET_POLICY',
  GET_POLICY_CANCEL: 'GET_POLICY_CANCEL',
  SET_POLICY_CANCEL: 'SET_POLICY_CANCEL',
  CANCEL_POLICIES: 'CANCEL_POLICIES',
  GET_BUILDING_DELEGATION: 'GET_BUILDING_DELEGATION',
  SET_BUILDING_DELEGATION: 'SET_BUILDING_DELEGATION',
  GET_BUILDING_INVOICE: 'GET_BUILDING_INVOICE',
  SET_BUILDING_INVOICE: 'SET_BUILDING_INVOICE',
  GET_POLICY_CANCEL_LOGS: 'GET_POLICY_CANCEL_LOGS',
  SET_POLICY_CANCEL_LOGS: 'SET_POLICY_CANCEL_LOGS',
  SET_POLICY_CANCEL_LOGS_ERROR: 'SET_POLICY_CANCEL_LOGS_ERROR',
  GET_POLICY_DETAIL: 'GET_POLICY_DETAIL',
  SET_POLICY_DETAIL: 'SET_POLICY_DETAIL',
  GET_APP_DETAIL: 'GET_APP_DETAIL',
  SET_APP_DETAIL: 'SET_APP_DETAIL',
  GET_CLAIM_DETAIL: 'GET_CLAIM_DETAIL',
  SET_CLAIM_DETAIL: 'SET_CLAIM_DETAIL',
  GET_BUILDING_DETAIL: 'GET_BUILDING_DETAIL',
  SET_BUILDING_DETAIL: 'SET_BUILDING_DETAIL',
  SET_APP_DETAIL_ERROR: 'SET_APP_DETAIL_ERROR',
  SET_POLICY_DETAIL_ERROR: 'SET_POLICY_DETAIL_ERROR',
  SET_CLAIM_DETAIL_ERROR: 'SET_CLAIM_DETAIL_ERROR',
  SET_BUILDING_DETAIL_ERROR: 'SET_BUILDING_DETAIL_ERROR',
  SET_BUILDING_ERROR: 'SET_BUILDING_ERROR',
  SET_APP_ERROR: 'SET_APP_ERROR',
  SET_POLICY_ERROR: 'SET_POLICY_ERROR',
  SET_CLAIM_ERROR: 'SET_CLAIM_ERROR',
};

export default propertyActionTypes;
